/* BATFIT 28/10/2026 : e-book offert ajouté tout seul au panier (remplace l'app CartBot).
   Règle : dès qu'il y a au moins 1 jogging AEGIS HeavyCore, ou au moins 4 AEGIS ExoSkin, ou (29/10/2026) au moins
   4 t-shirts classiques (Spiderman, Batman… mélangés : réduction PACK 4 T-SHIRTS, snippets/bf-tee-packs.liquid) dans le panier,
   l'e-book « Transformation physique » est ajouté une fois (la remise automatique EBOOK OFFERT le met à 0 €).
   Comme CartBot : on ajoute, on ne retire jamais, jamais en double.
   Si le client retire lui-même l'e-book du panier, il n'est pas remis (le temps de la visite),
   sauf si le panier se vide puis se remplit de nouveau.
   Vérifie le panier au chargement de chaque page et après chaque ajout ou changement de panier
   (fiche produit, packs, barre d'achat, panier latéral, page panier).
   Chargé depuis snippets/bf-performance-head.liquid, sur toutes les pages.
   29/10/2026 : window.BFEbookOffert.pret() — attendre l'e-book avant un départ direct vers le paiement (paiement rapide). */
(function () {
  try {
    if (window.__bfEbookOffert) return;
    window.__bfEbookOffert = true;

    var EBOOK_VARIANT = 54208442237251;   /* EBOOK « transformation physique » */
    var HEAVYCORE_PRODUIT = 14775832674627; /* AEGIS – HeavyCore (jogging) */
    var EXOSKIN_PRODUIT = 15099035484483;   /* AEGIS – ExoSkin */
    var EXOSKIN_MIN = 4;
    /* t-shirts classiques = les produits des réductions PACK 2 / PACK 4 T-SHIRTS (même liste que bf_tp_ids dans bf-tee-packs) */
    var CLASSIQUES = [8757850997059, 8760354242883, 8761147883843, 8773507776835, 9005543391555, 9644159631683, 9644159861059, 9644159926595, 9644159959363, 9644171755843, 15457899381059, 15457899413827, 15457899446595, 15457899479363, 15457899512131, 15457899544899, 15457899577667, 15457899610435, 15457899643203, 15457900659011];
    var CLASSIQUES_MIN = 4;

    var fetchOrig = window.fetch.bind(window);
    var occupe = false, aRevoir = false;
    var JSON_H = { 'Content-Type': 'application/json', 'Accept': 'application/json' };

    function estPanier(url) { return /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/.test(String(url || '')); }

    var avaitEbook = null; /* l'e-book était-il dans le panier au dernier contrôle ? (null = pas encore vu) */
    function refuse(v) {
      try {
        if (v === undefined) return sessionStorage.getItem('bfEbookRetire') === '1';
        if (v) sessionStorage.setItem('bfEbookRetire', '1'); else sessionStorage.removeItem('bfEbookRetire');
      } catch (e) { return false; }
    }

    function doitOffrir(cart) {
      var jog = 0, exo = 0, cla = 0, ebook = 0;
      (cart.items || []).forEach(function (i) {
        if (i.product_id === HEAVYCORE_PRODUIT) jog += i.quantity;
        if (i.product_id === EXOSKIN_PRODUIT) exo += i.quantity;
        if (CLASSIQUES.indexOf(i.product_id) !== -1) cla += i.quantity;
        if (i.variant_id === EBOOK_VARIANT) ebook += i.quantity;
      });
      var eligible = jog >= 1 || exo >= EXOSKIN_MIN || cla >= CLASSIQUES_MIN;
      if (!(cart.item_count > 0)) refuse(false);                 /* panier vide : on repart de zéro */
      if (avaitEbook === true && ebook === 0 && eligible) refuse(true); /* le client vient de le retirer */
      avaitEbook = ebook > 0;
      return ebook === 0 && eligible && !refuse();
    }

    /* remet à jour le panier latéral, la pastille du panier et la page panier */
    function rafraichir() {
      return fetchOrig('/?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (s) {
          var p = new DOMParser();
          var d = document.querySelector('cart-drawer');
          if (s && s['cart-drawer'] && d) {
            var n = p.parseFromString(s['cart-drawer'], 'text/html').querySelector('.drawer__inner');
            var a = d.querySelector('.drawer__inner');
            if (n && a) { a.innerHTML = n.innerHTML; d.classList.remove('is-empty'); }
          }
          if (s && s['cart-icon-bubble']) {
            var doc = p.parseFromString(s['cart-icon-bubble'], 'text/html');
            var nb = doc.querySelector('.shopify-section');
            var ab = document.getElementById('cart-icon-bubble');
            if (nb && ab) ab.innerHTML = nb.innerHTML;
          }
          if (/^\/cart\/?$/.test(location.pathname)) {
            var ci = document.querySelector('cart-items');
            if (ci && typeof ci.onCartUpdate === 'function') ci.onCartUpdate(); else location.reload();
          }
        });
    }

    /* renvoie une promesse : terminée quand le panier est contrôlé (et l'e-book ajouté s'il le faut) */
    var enCours = null;
    function verifier() {
      if (occupe) { aRevoir = true; return enCours; }
      occupe = true;
      enCours = fetchOrig('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (!doitOffrir(cart)) return false;
          return fetchOrig('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: JSON_H, body: JSON.stringify({ items: [{ id: EBOOK_VARIANT, quantity: 1 }] }) })
            .then(function (r) { if (!r.ok) throw new Error('ebook'); avaitEbook = true; return true; });
        })
        .then(function (ajoute) { if (ajoute) return rafraichir(); })
        .catch(function () {})
        .then(function () {
          occupe = false;
          if (aRevoir) { aRevoir = false; return verifier(); }
        });
      return enCours;
    }
    /* BATFIT 29/10/2026 : paiement rapide (Apple Pay / PayPal des fiches, avis en stories) — le client part tout de suite
       vers la page de paiement : avant d'y aller, on attend que l'e-book offert soit dans le panier (3 s au plus).
       Utilisé par snippets/bf-paiement-express.liquid et assets/bf-avis-stories.js. */
    window.BFEbookOffert = {
      pret: function () {
        return Promise.race([Promise.resolve(verifier()), new Promise(function (r) { setTimeout(r, 3000); })]);
      }
    };

    /* écoute tous les ajouts et changements de panier faits par la page (fetch et XHR) */
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/clear/.test(url)) { avaitEbook = false; refuse(false); }
      var promesse = fetchOrig(input, init);
      if (estPanier(url)) promesse.then(function (r) { if (r && r.ok) setTimeout(verifier, 150); }).catch(function () {});
      return promesse;
    };
    var xOpen = XMLHttpRequest.prototype.open, xSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, url) { this.__bfUrl = url; return xOpen.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      var x = this;
      if (estPanier(x.__bfUrl)) x.addEventListener('load', function () { if (x.status < 400) setTimeout(verifier, 150); });
      return xSend.apply(this, arguments);
    };

    /* au chargement de la page (panier gardé d'une visite précédente, ajout par formulaire classique) */
    verifier();
  } catch (e) {}
})();
